import { Component, OnInit } from '@angular/core';
import { AuthUserService, UserQuery } from '@transfora/authentication';
import { Environment } from '@transfora/core';

@Component({
  selector: 'app-no-privilege',
  templateUrl: './no-privilege.component.html',
  styleUrls: ['./no-privilege.component.scss']
})
export class NoPrivilegeComponent implements OnInit {

  constructor(private environment: Environment,
    private service: AuthUserService<{}>,
    private query: UserQuery<{}>) {}

  ngOnInit(): void {}

  redirectToPortal() {
    window.location.href = this.environment.portal_uri;
  }

  signOut() {
    this.service.signoutRedirect({
      id_token_hint: this.query.getValue().id_token
    });
  }

}
